export const nav = 1;

export const getStates = (menu = "sync-data", other) => {
  const base = menu;
  return {
    [base]: {
      nav,
      menu, // <ui-view/>
      breadcrumbs: true,
      pageHeader: true,
      landing: true,
      icon: "database",
      title: "Sync Data",
      url: "/" + base, // + "?uploaded&mode",
      params: {},
      // rerouteTo: `${base}.list`,
      authorize: s =>
        s.isOffline() /*&& !s.isShowroom() */ && s.isAuthenticated,
      templateProvider: $stateParams => `<sync-data-file-container  />`,
      ...other
    }
  };
};

export default getStates();
